import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { showError, showSuccess } from "common/ToastNotifications";
import { AiUsage as AiUsageView, LoadingOverlay, ProhibitedArea } from "components";
import actions from "store/actions";

function today() {
  return new Date().toISOString().slice(0, 10);
}
function daysAgo(days) {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - (days - 1));
  return d.toISOString().slice(0, 10);
}

function AiUsage(props) {
  const [range, setRange] = useState({ from: daysAgo(30), to: today() });

  const prev = useRef(null);
  if (prev.current === null) {
    prev.current = { setBudgetResult: props.setBudgetResult };
  }

  useEffect(() => {
    props.getUsageSummary(range);
    props.getUsageDaily(range);
    props.getUsageByModel(range);
    props.getUsageByCapability(range);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range.from, range.to]);

  useEffect(() => {
    props.getUsagePermission();
    props.getUsageBudget();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.setBudgetResult !== prev.current.setBudgetResult) {
      prev.current.setBudgetResult = props.setBudgetResult;
      if (props.setBudgetResult && props.setBudgetResult.success === false) {
        showError(props.setBudgetResult.message || "Could not save the budget.");
      } else if (props.setBudgetResult) {
        showSuccess("Budget saved.");
      }
    }
  }, [props.setBudgetResult]); // eslint-disable-line react-hooks/exhaustive-deps

  if (props.permission && !props.permission.canView) {
    return <ProhibitedArea />;
  }

  return (
    <div className="relative" style={{ height: "100%" }}>
      <LoadingOverlay busy={props.loading} spinner message="Please wait..." />
      <AiUsageView
        range={range}
        onRangeChange={setRange}
        summary={props.summary}
        daily={props.daily}
        byModel={props.byModel}
        byCapability={props.byCapability}
        budget={props.budget}
        savingBudget={props.savingBudget}
        permission={props.permission}
        onSaveBudget={props.setUsageBudget}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  summary: state.aiUsage.summary,
  daily: state.aiUsage.daily,
  byModel: state.aiUsage.byModel,
  byCapability: state.aiUsage.byCapability,
  budget: state.aiUsage.budget,
  permission: state.aiUsage.permission,
  loading: state.aiUsage.loading,
  savingBudget: state.aiUsage.savingBudget,
  setBudgetResult: state.aiUsage.setBudgetResult,
});

const mapDispatchToProps = (dispatch) => ({
  getUsageSummary: (range) => dispatch(actions.getUsageSummaryRequest(range)),
  getUsageDaily: (range) => dispatch(actions.getUsageDailyRequest(range)),
  getUsageByModel: (range) => dispatch(actions.getUsageByModelRequest(range)),
  getUsageByCapability: (range) => dispatch(actions.getUsageByCapabilityRequest(range)),
  getUsageBudget: () => dispatch(actions.getUsageBudgetRequest()),
  setUsageBudget: (budget) => dispatch(actions.setUsageBudgetRequest(budget)),
  getUsagePermission: () => dispatch(actions.getUsagePermissionRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AiUsage);
